import capitalStructureChartData from './mock/fundermantal-data/1928.HK.capitalStructureChartData'
import leverageChartData from './mock/fundermantal-data/1928.HK.leverageChartData'
import debtCoverageBurdenChartData from './mock/fundermantal-data/1928.HK.debtCoverageBurdenChartData'
import assetStructureChartData from './mock/fundermantal-data/1928.HK.assetStructureChartData'
import assetStabilityChartData from './mock/fundermantal-data/1928.HK.assetStabilityChartData'
import assetLiquidityChartData from './mock/fundermantal-data/1928.HK.assetLiquidityChartData'
import costStructureChartData from './mock/fundermantal-data/1928.HK.costStructureChartData'
import cashGenerationChartData from './mock/fundermantal-data/1928.HK.cashGenerationChartData'
import earningsAndValuationRiskChartData from './mock/fundermantal-data/1928.HK.earningsAndValuationRiskChartData'

const charts = [
  {
    id: 1,
    title: 'Cap Structure',
    relationships: [2, 3],
    text: 'Does the company have an appropriate and serviceable level of debt?',
    mockData: capitalStructureChartData,
    data: [],
    type: 'StackedAreaChart',
    group: 'A',
    tooltipInfo: {
      corporate: {
        title: 'Cap Structure',
        whatToShow: 'How does the company fund itself? How has that changed?',
        thingsToLookOutFor:
          'Every company has their own blend of debt, equity and ‘other’ funding such as accounts payable. Abnormal change in this blend may indicate a change in management behaviour OR that the company is finding it harder to access its usual sources of funding. It may also indicate risk of a capital structure event such as new debt or equity issuance.',
        nextBestAction:
          'If you see an abnormal change in this chart, look at the liabilities section of the company balance sheet for a more detailed breakout of what’s driven that change.',
      },
      bank: {
        title: 'Cap Structure',
        whatToShow: 'How does the company fund itself? How has that changed?',
        thingsToLookOutFor:
          'Every bank has their own blend of deposits, long- and short-term wholesale funding, equity and ‘other’. Abnormal change in this blend may indicate a change in management behaviour OR that the company is finding it harder to access its usual sources of funding. It may also indicate risk of a capital structure event such as new debt or equity issuance.',
        nextBestAction:
          'If you see an abnormal change in this chart, look at the liabilities section of the company balance sheet for a more detailed breakout of what’s driven that change.',
      },
      property: {
        title: 'Cap Structure',
        whatToShow: 'How does the company fund itself? How has that changed?',
        thingsToLookOutFor:
          'Every company has their own blend of debt, equity and ‘other’ funding such as accounts payable. Abnormal change in this blend may indicate a change in management behaviour OR that the company is finding it harder to access its usual sources of funding. It may also indicate risk of a capital structure event such as new debt or equity issuance.',
        nextBestAction:
          'If you see an abnormal change in this chart, look at the liabilities section of the company balance sheet for a more detailed breakout of what’s driven that change.',
      },
    },
    stackKeys: {
      corporate: [
        {
          title: 'Other Long Term',
          key: 'others_lt',
        },
        {
          title: 'Other Short Term',
          key: 'others_st',
        },
        {
          title: 'Equity',
          key: 'shareholders_equity',
        },
        {
          title: 'Short Term Debt',
          key: 'short_term_debt',
        },
        {
          title: 'Long Term Debt',
          key: 'long_term_debt',
        },
      ],
      bank: [
        {
          title: 'Equity',
          key: 'shareholders_equity',
        },
        {
          title: 'Others',
          key: 'others',
        },
        {
          title: 'Short Term Wholesale',
          key: 'short_term_debt',
        },
        {
          title: 'Long Term Wholesale',
          key: 'long_term_debt',
        },
        {
          title: 'Total Deposits',
          key: 'total_deposits',
        },
      ],
      property: [
        {
          title: 'ShareHolders Equity',
          key: 'shareholders_equity',
        },
        {
          title: 'Others',
          key: 'others',
        },
        {
          title: 'Short Term Wholesale',
          key: 'short_term_debt',
        },
        {
          title: 'Long Term Wholesale',
          key: 'long_term_debt',
        },
      ],
    },
  },
  {
    id: 4,
    title: 'Asset Structure',
    group: 'B',
    relationships: [5, 6],
    text:
      'Does the company have an appropriate balance of cash, physical assets and intangibles?',
    mockData: assetStructureChartData,
    data: [],
    type: 'StackedAreaChart',
    tooltipInfo: {
      corporate: {
        title: `Asset Composition`,
        whatToShow: `What is the structure of assets on the balance sheet? How has this changed?`,
        purpose: null,
        thingsToLookOutFor: `Every company has their own blend of cash, physical assets (PP&E) and intangibles such as deferred tax assets and intellectual property. Abnormal change in this blend may indicate a change in management behaviour OR a change in the quality and solidity of the asset base that could indicate risk of asset impairment or lower recovery rates in event of default.`,
        nextBestAction: `If you see an abnormal change in this chart, look at the asset section of the balance sheet for breakout detail of what's driven that change. Particularly consider the balance between cash/physical assets and everything else, and whether the value of those non-physical assets makes sense to you.`,
      },
      bank: {
        title: `Asset Composition`,
        whatToShow: `What is the structure of assets on the balance sheet? How has this changed?`,
        purpose: null,
        thingsToLookOutFor: `Every bank has their own blend of cash, loans, investments and other assets. Abnormal change in this blend may indicate a change in management behaviour OR a change in the quality and solidity of the asset base that could indicate risk of asset impairment or lower recovery rates in event of default.`,
        nextBestAction: `If you see an abnormal change in this chart, look at the asset section of the balance sheet for breakout detail of what's driven that change. Particularly consider the balance between cash and everything else, and whether any over-reliance on investments or abnormal loan growth could impact your investment thesis on the company. `,
      },
      property: {
        title: `Asset Composition`,
        whatToShow: `What is the structure of assets on the balance sheet? How has this changed?`,
        purpose: null,
        thingsToLookOutFor: `Every company has their own blend of cash, property and physical assets (PP&E) and intangibles such as deferred tax assets and investment in affiliates. Abnormal change in this blend may indicate a change in management behaviour OR a change in the quality and solidity of the asset base that could indicate risk of asset impairment or lower recovery rates in event of default.`,
        nextBestAction: `If you see an abnormal change in this chart, look at the asset section of the balance sheet for breakout detail of what's driven that change. Particularly consider the balance between cash/physical assets and everything else, and whether the value of those non-physical assets makes sense to you.`,
      },
    },
    stackKeys: {
      corporate: [
        {
          title: 'Other Fixed',
          key: 'ot_fixed',
        },
        {
          title: 'Non-Cash Current',
          key: 'non_cash_curr',
        },
        {
          title: 'Net PP&E',
          key: 'net_ppe',
        },
        {
          title: 'Cash & ST',
          key: 'cash',
        },
      ],
      bank: [
        {
          title: 'Other',
          key: 'net_assets',
        },
        {
          title: 'Investments',
          key: 'total_bank_investments',
        },
        {
          title: 'Net Loans',
          key: 'net_loan',
        },
        {
          title: 'Cash & ST',
          key: 'total_cash_due_banks',
        },
      ],
      property: [
        {
          title: 'Other',
          key: 'net_assets',
        },
        {
          title: 'Affiliate Investments',
          key: 'invest_unconsol_subs',
        },
        {
          title: 'Receivables',
          key: 'total_accounts_receivable',
        },
        {
          title: 'PP&E',
          key: 'net_prop_plant_equipment',
        },
        {
          title: 'Investment Property',
          key: 'real_estate_assets',
        },
        {
          title: 'Cash',
          key: 'short_term_cash_investments',
        },
      ],
    },
  },
  {
    id: 7,
    title: 'Cost Structure',
    group: 'C',
    relationships: [8, 9],
    text:
      'Are there abnormal changes or dislocations in the income statement that could flow through to cashflows or valuation?',
    mockData: costStructureChartData,
    data: [],
    type: 'StackedAreaChart',
    tooltipInfo: {
      corporate: {
        title: `Cost Structure`,
        whatToShow: `What is the cost structure of the company? How has this changed?`,
        purpose: null,
        thingsToLookOutFor: `Every company has their own blend of costs, but this blend tends to stay broadly constant over time. Abnormal change in this blend may indicate a major change in business model or conditions but may also indicate management efforts to 'manage' the reported profits by compressing, inflating, deferring or shifting costs around the income statement. Look out, in particular, for abnormal changes in 'Non-operating costs' and 'Other operating costs' which relate more to pure accounting and have less of a close link to day-to-day business operations than CoGs and SG&A. Bear in mind that every additional $ of cost means one less $ of profit margin and consider the potential impact of this on things like debt servicing.`,
        nextBestAction: `If you see abnormal change in this chart, look at the company's Income Statement to find out why. It's worth looking at things like the relative size - and composition - of SG&A (Sales, General & Admin Expenses) and CoGs (Cost of Goods Sold). 'Other Operating Costs' and 'Non-Operating Costs' are often where companies put items like impairments so look for details if either of these lines has risen. Also ask if any cost lines look artificially or abnormally low and if so, look for details of why. It may be worth stress testing your model to see how a normalisation or rise in costs would affect fair value.`,
      },
      bank: {
        title: `Composition of Income`,
        whatToShow: `What is the composition of income? How has this changed?`,
        purpose: null,
        thingsToLookOutFor: `Every bank has their own blend of net interest, fee business and investment income, but this blend tends to stay broadly constant over time. Abnormal change in this blend may indicate a major change in business model or conditions but may also indicate management efforts to 'manage' the reported profits by compressing, inflating, deferring or shifting items around the income statement. Look out, for example, for outsize reliance on investment income – particularly if it ‘fills a gap’ in net interest or non-interest income.`,
        nextBestAction: `If you see abnormal change in this chart, look at the company's Income Statement to find out why. Think about things like outsize loan growth and its implications for credit cost or leverage. Think about outsize investment income and how sustainable it is. What would a normalisation in these values do to your assumptions on the company?`,
      },
      property: {
        title: `Cost Structure`,
        whatToShow: `What is the cost structure of the company? How has this changed?`,
        purpose: null,
        thingsToLookOutFor: `Every company has their own blend of costs, but this blend tends to stay broadly constant over time. Abnormal change in this blend may indicate a major change in business model or conditions but may also indicate management efforts to 'manage' the reported profits by compressing, inflating, deferring or shifting costs around the income statement. Look out, in particular, for abnormal changes in 'Non-operating costs' and 'Other operating costs' which relate more to pure accounting and have less of a close link to day-to-day business operations than CoGs and SG&A. Bear in mind that every additional $ of cost means one less $ of profit margin and consider the potential impact of this on things like debt servicing.`,
        nextBestAction: `If you see abnormal change in this chart, look at the company's Income Statement to find out why. It's worth looking at things like the relative size - and composition - of SG&A (Sales, General & Admin Expenses) and CoGs (Cost of Goods Sold). 'Other Operating Costs' and 'Non-Operating Costs' are often where companies put items like impairments so look for details if either of these lines has risen. Also ask if any cost lines look artificially or abnormally low and if so, look for details of why. It may be worth stress testing your model to see how a normalisation or rise in costs would affect fair value.`,
      },
    },
    stackKeys: {
      corporate: [
        {
          title: 'Dividends Paid Out',
          key: 'div_paid',
        },
        {
          title: 'Non-Operating Cost',
          key: 'non_oper_cost',
        },
        {
          title: 'Other Operating Cost',
          key: 'oth_oper_cost',
        },
        {
          title: 'S&GA',
          key: 'sga',
        },
        {
          title: 'CoGs',
          key: 'cogs',
        },
      ],
      bank: [
        {
          title: 'Securities Gain',
          key: 'securities_gain',
        },
        {
          title: 'Non-Interest Income',
          key: 'non_interest_income',
        },
        {
          title: 'Net Interest Income',
          key: 'net_interest',
        },
      ],
      property: [
        {
          title: 'Dividends Paid Out',
          key: 'div_paid',
        },
        {
          title: 'Non Operating Expense',
          key: 'non_oper_cost',
        },
        {
          title: 'Other Operating Expense',
          key: 'oth_oper_cost',
        },
        {
          title: 'SG&A',
          key: 'selling_general_expense',
        },
        {
          title: 'CoGS',
          key: 'cost_of_goods_sold',
        },
      ],
    },
  },
  {
    id: 2,
    title: 'Leverage Index',
    relationships: [1, 9],
    group: 'A',
    text:
      'Is leverage appropriate in context of the overall capital structure? How is it being affected by equity market valuation?',
    mockData: leverageChartData,
    data: [],
    type: 'LineChart',
    lineKeys: {
      corporate: ['debt_over_mcap_deviation', 'debt_over_mcap_h_deviation'],
      bank: [
        'loan_over_total_deposits_deviation',
        'loan_over_total_deposits_h_deviation',
      ],
      property: [
        'debt_over_marketcap_deviation',
        'debt_over_marketcap_h_deviation',
      ],
    },
    tooltipInfo: {
      corporate: {
        title: 'Leverage Index',
        subTitle: 'Net Debt / Market Cap',
        whatToShow:
          'Net Debt / Market Cap – standard deviations away from company history, and from country/sector peer group.',
        purpose:
          'How large is the company’s debt burden in context of the capital structure?',
        thingsToLookOutFor:
          'A spike in LDR may indicate one of two things: either loans are growing more rapidly than normal, or deposits are under abnormal pressure. These may reflect changes in market environment (e.g. macro growth or deposit competition) or management behaviour and risk appetite.',
        nextBestAction:
          "Use this chart in combination with Capital Structure chart and Funding Stability chart to get a sense of what's driving any change. Markets often like leverage until it mean-reverts. So look at Equity Valuation and Asset Quality to determine if the company is priced for outsize growth or is taking on abnormal risks and consider stress testing your model for any normalisation in this ratio. ",
      },
      bank: {
        title: 'Leverage Index',
        subTitle: 'Loan / Deposit Ratio',
        whatToShow:
          'Loan / Deposit Ratio – standard deviations away from company history, and from country/sector peer group.',
        purpose:
          'How large is the company’s balance sheet in context of its core funding base?',
        thingsToLookOutFor:
          'A spike in LDR may indicate one of two things: either loans are growing more rapidly than normal, or deposits are under abnormal pressure. These may reflect changes in market environment (e.g. macro growth or deposit competition) or management behaviour and risk appetite.',
        nextBestAction:
          'Use this chart in combination with Capital Structure chart and Funding Stability chart to get a sense of whats driving any change. Markets often like leverage until it mean-reverts. So look at Equity Valuation and Asset Quality to determine if the company is priced for outsize growth or is taking on abnormal risks and consider stress testing your model for any normalisation in this ratio. ',
      },
      property: {
        title: 'Leverage Index',
        subTitle: 'Net Debt / Market Cap',
        whatToShow:
          'Net Debt / Market Cap – standard deviations away from company history, and from country/sector peer group.',
        purpose:
          'How large is the company’s debt burden in context of the capital structure?',
        thingsToLookOutFor:
          "A spike in leverage may indicate one of two things: either the market value of the company's equity is being de-rated OR the company has taken on an abnormally high level of debt. This may indicate fundamental stress being priced in by equity markets, or may indicate risk of dilutive new equity issuance.",
        nextBestAction:
          "Use this chart in combination with Capital Structure chart and Equity Market Valuation chart to get a sense of what's driving any change – is it a rise in debt? Or a fall in equity? Bear in mind M&A can often lead to large dislocations in this ratio, and if this is the case, look at Asset Structure chart to see what the company has done with any new debt or equity that’s been raised.",
      },
    },
  },
  {
    id: 5,
    group: 'B',
    title: 'Asset Stability Index',
    relationships: [4, 1],
    text:
      "Think of the company's assets in context of the overall balance sheet. How are they funded? Is there a risk of impairment?",
    mockData: assetStabilityChartData,
    data: [],
    type: 'LineChart',
    lineKeys: {
      corporate: ['tang_over_assets_deviation', 'tang_over_assets_h_deviation'],
      bank: ['non_perf_loan_deviation', 'non_perf_loan_h_deviation'],
      property: [
        'tangible_over_bps_deviation',
        'tangible_over_bps_h_deviation',
      ],
    },
    tooltipInfo: {
      corporate: {
        title: `Asset Stability Index`,
        subTitle: 'Net PP&E / Net Assets',
        whatToShow: `Physical Assets (represented by Net PP&E) / Total Assets – standard deviations away from company history, and from country/sector peer group.`,
        purpose: `How solid are the fixed assets on the company balance sheet? Has this changed?`,
        thingsToLookOutFor: `PP&E (Property, Plant & Equipment) represents the 'hard' physical assets on a company balance sheet. A fall in this ratio may indicate that the company is liquidating physical assets - a sign of possible stress. Alternatively it may indicate that the company's value is more reliant on intangibles - which may increase the risk of future asset impairment or lower recovery post-default.`,
        nextBestAction: `If you see an abnormal change in this chart, Chart Asset Structure should help give a basic idea what-s driving it - e.g. whether it's a rise in intangibles or a fall in physical assets. To find more detail, visit the Fixed Asset section of the company balance sheet. Think about the value being placed on the company's physical assets - particularly intangible ones - and if necessary, think about stress testing your model to see what any impairments would do to fair value.`,
      },
      bank: {
        title: `Asset Quality Index`,
        subTitle: 'Non-Performing Loan Ratio',
        whatToShow: `Nonperforming Loan Ratio – standard deviations away from company history, and from country/sector peer group.`,
        purpose: `What kind of credit cost trends are coming out of the company loan book? Has this changed?`,
        thingsToLookOutFor: `The NPL ratio can’t tell the whole story around asset quality, but it’s a helpful starting point. Any abnormal spike in this ratio may indicate a change in credit cycle or in management risk-appetite and lending behaviours. An abnormally low one may indicate uncrystallised risk e.g. off-balance sheet exposures or inadequate provisioning and impairment practices.`,
        nextBestAction: `If you see an abnormal change in this chart, look at recent loan growth as represented in the Leverage and Asset Composition Charts, and consider how any impairment could affect profitability, capitalisation or valuation. `,
      },
      property: {
        title: `Asset Stability Index`,
        subTitle: 'Tangible Bk Per Share / Bk Per Share',
        whatToShow: `Tangible Book per Share / Book per Share – standard deviations away from company history, and from country/sector peer group.`,
        purpose: `How tangible are the assets on the company balance sheet? Has this changed?`,
        thingsToLookOutFor: `An abnormal change in this ratio could indicate a change in valuation of the company’s physical assets, or a change in management behaviour e.g. an increasing use of off-balance sheet vehicles or affiliate investments. This can increase impairment risk, or show management efforts to avoid breaching covenants or restrictions relating to balance sheet size.`,
        nextBestAction: `If you see an abnormal change in this chart, look at the balance sheet and consider your asset value assumptions for the company. Is there a risk of impairment in intangibles that could affect the company’s financial position, fair value or recovery rates in case of default?`,
      },
    },
  },
  {
    id: 8,
    group: 'C',
    title: 'Cash Generation Index',
    relationships: [3, 9],
    text:
      'Does cashflow generation suggest any risk to debt servicing, or to reported earnings and market valuation / sentiment?',
    mockData: cashGenerationChartData,
    data: [],
    type: 'LineChart',
    lineKeys: {
      corporate: [
        'earnings_cashflow_deviation',
        'earnings_cashflow_h_deviation',
      ],
      bank: ['icgr_deviation', 'icgr_h_deviation'],
      property: [
        'excess_fcf_margin_deviation',
        'excess_fcf_margin_h_deviation',
      ],
    },
    tooltipInfo: {
      corporate: {
        title: `Cash Generation Index`,
        subTitle: 'Diff Net Op Cashflows & Net Income',
        whatToShow: `Spread between Net Operating Cashflows and Net Income – standard deviations away from company history, and from country/sector peer group.`,
        purpose: `Are the company's earnings supported by healthy cashflow generation?`,
        thingsToLookOutFor: `Whilst earnings are important, cashflow is necessary for a company to pay dividends, conduct buybacks or invest for growth. This ratio measures whether a company's cashflow generation is as healthy as its reported profits in the form of a spread between profit margins (Net Profit) and operating cashflow margins. If it rises, the company is converting more of its profits into cashflow, if it falls then the opposite is true. Consistently weak cashflow generation may result in capital structure stress such as debt or equity issuance, or in the liquidation of assets to fill the gap.`,
        nextBestAction: `Consider this chart in coordination with chart Capital structure and chart Debt servicing. It's also worth considering it in conjunction with Chart equity market valuation as a company richly valued on earnings basis may be more vulnerable to a shock. Cashflow weakness may manifest in multiple ways - dividend cuts, earnings downgrades, asset liquidation or capital structure event (e.g. issuance). Look at the company's cashflow statement for more detail.`,
      },
      bank: {
        title: `Capital Generation Index`,
        subTitle: 'Internal Capital Generation Ratio',
        whatToShow: `Internal Capital Generation Ratio (ICGR) – standard deviations away from company history, and from country/sector peer group.`,
        purpose: `Are the bank’s capital levels sustainable? Growing or shrinking? Is there any change in trend?`,
        thingsToLookOutFor: `ICGR is Return on Equity after the payout of dividends (RoE * 1-Payout Ratio). It represents the actual amount of equity being generated back into the business each year. A decline in this ratio indicates either a deterioration in core capital generation or that the company is overpaying dividends. This creates the risk of either future dividend cuts, or constraints on growth and leverage due the lack of sustainable capital generation.`,
        nextBestAction: `Consider this chart in coordination with the Cap Structure, Income Composition and Market Valuation charts. Has deterioration been driven by an erosion in earnings? A change in equity valuation? A change in dividend payout policy? Consider what a normalisation would mean for your assumptions.`,
      },
      property: {
        title: `Cash Generation Index`,
        subTitle: 'Net Op Cashflows - Net Income',
        whatToShow: `Spread between Free Cashflow and Net Income – standard deviations away from company history, and from country/sector peer group`,
        purpose: `Are the company's earnings supported by healthy cashflow generation?`,
        thingsToLookOutFor: `Whilst earnings are important, cashflow is necessary for a company to pay dividends, conduct buybacks or invest for growth. This ratio measures whether a company's cashflow generation is as healthy as its reported profits in the form of a spread between profit margins (Net Profit) and free cashflow margins. If it rises, the company is converting more of its profits into cashflow, if it falls then the opposite is true. Consistently weak cashflow generation may result in capital structure stress such as debt or equity issuance, or in the liquidation of assets to fill the gap.`,
        nextBestAction: `Consider this chart in coordination with chart Capital structure and chart Debt servicing. It's also worth considering it in conjunction with Chart equity market valuation as a company richly valued on earnings basis may be more vulnerable to a shock. Cashflow weakness may manifest in multiple ways - dividend cuts, earnings downgrades, asset liquidation or capital structure event (e.g. issuance). Look at the company's cashflow statement for more detail.`,
      },
    },
  },
  {
    id: 3,
    title: 'Debt Coverage Burden Index',
    group: 'A',
    relationships: [7, 8],
    text:
      'Has there been a dislocation in the income statement or in cashflow generation that might affect debt servicing?',
    mockData: debtCoverageBurdenChartData,
    data: [],
    type: 'LineChart',
    lineKeys: {
      corporate: ['debt_over_ebit_deviation', 'debt_over_ebit_h_deviation'],
      bank: [
        'deps_over_liabilities_deviation',
        'deps_over_liabilities_h_deviation',
      ],
      property: [
        'fundsoperation_over_debt_deviation',
        'fundsoperation_over_debt_h_deviation',
      ],
    },
    tooltipInfo: {
      corporate: {
        title: `Debt Coverage Burden Index`,
        subTitle: 'Net Debt / EBIT',
        whatToShow: `Net Debt / EBIT – standard deviations away from company history, and from country/sector peer group.`,
        purpose: `How capable is the company of servicing its debt load with profits?`,
        thingsToLookOutFor: `A spike in Net Debt/EBIT may indicate that the company has taken on an excessive level of debt and may struggle to service it OR that a collapse in EBIT endangers the stable servicing of debt payments.`,
        nextBestAction: `Look at this chart in conjunction with charts Cost structure and Leverage to understand what's driving it. Is it a rise in debt? Or a fall in profits? It's also worth looking at charts Cash generation Equity valuation to understand potential future risks. If there is downside risk to earnings, OR if the company isn't converting its earnings into cashflow then a debt servicing problem may become particularly acute.`,
      },
      bank: {
        title: `Funding Stability Index`,
        subTitle: 'Deposits / Total Funding',
        whatToShow: `Deposits / Total Funding – standard deviations away from company history, and from country/sector peer group.`,
        purpose: `How stable is the company’s funding base?`,
        thingsToLookOutFor: `An abnormal reduction in deposits to total funding may reflect competitive pressure, weakening ability to gather and retain depositors or a change in management behaviour e.g. decision to rely more on wholesale funding. `,
        nextBestAction: `Look at this chart in conjunction with the Cap Structure chart to put it in context. Then ask why deposits are falling. Look at deposit rate trends in the company’s main market(s). If wholesale funding reliance has risen, also consider your view on yield curves and whether that greater curve exposure is a positive or negative in relation to your view of the company. `,
      },
      property: {
        title: `Debt Coverage Burden Index`,
        subTitle: 'FFO / Total Debt',
        whatToShow: `FFO / Total Debt – standard deviations away from company history, and from country/sector peer group.`,
        purpose: `How serviceable is the company’s debt burden? `,
        thingsToLookOutFor: `A sharp fall in FFO / Debt may indicate that the company has taken on an excessive level of debt and may struggle to service it OR that a collapse in profits and cashflows endanger the stable servicing of debt payments.`,
        nextBestAction: `Look at this chart in conjunction with charts Cost structure and Leverage to understand what's driving it. Is it a rise in debt? Or a fall in profits? It's also worth looking at charts Cash generation Equity valuation to understand potential future risks. If there is downside risk to earnings, OR if the company isn't converting its earnings into cashflow then a debt servicing problem may become particularly acute.`,
      },
    },
  },
  {
    id: 6,
    group: 'B',
    title: 'Asset Liquidity Index',
    relationships: [3, 8],
    text:
      'Is balance sheet cash being replenished or maintained by operations? Could it underpin debt servicing or repayment if needed?',
    mockData: assetLiquidityChartData,
    data: [],
    type: 'LineChart',
    lineKeys: {
      corporate: [
        'cash_as_pct_curr_assets_deviation',
        'cash_as_pct_curr_assets_h_deviation',
      ],
      bank: [
        'cash_securities_pct_deviation',
        'cash_securities_pct_h_deviation',
      ],
      property: ['cash_over_assets_deviation', 'cash_over_assets_h_deviation'],
    },
    tooltipInfo: {
      corporate: {
        title: `Asset Liquidity Index`,
        subTitle: 'Cash / Current Assets',
        whatToShow: `Cash / Current Assets – standard deviations away from company history, and from country/sector peer group.`,
        purpose: `How liquid are the assets on the company balance sheet? Has this changed?`,
        thingsToLookOutFor: `A fall in this ratio may indicate that the company's cash levels have been drawn down - a sign of possible stress. Alternatively, it may indicate that the company is relying on non-cash items like accounts receivable or investments - which may increase the risk of future liquidity shock if these cannot be turned into cash.`,
        nextBestAction: `If you see abnormal change in this chart, look at Chart Asset Structure for a basic idea of what's driving it. You'll find further detail in the Current Assets section of the company balance sheet. Think about the company's cash levels in conjunction with Chart Debt coverage burden and Chart Cash generation. Are cash levels being replenished well by profits? Can they support debt servicing requirements if needed? It might also be worth checking the cashflow statement of the company to see more detail if the company is burning cash. Think how long the cash will last at current burn, and stress test your models accordingly.`,
      },
      bank: {
        title: `Asset Liquidity Index`,
        subTitle: 'Cash / Current Assets',
        whatToShow: `Cash / Current Assets – standard deviations away from company history, and from country/sector peer group.`,
        purpose: `How liquid are the assets on the company balance sheet? Has this changed?`,
        thingsToLookOutFor: `This ratio represents the core ability of a bank to cover its deposit base with liquid assets if needed. A fall indicates potential liquidity risk or that the company is growing assets like the loan book more aggressively relative to its stable funding base.`,
        nextBestAction: `If you see abnormal change in this chart, look at the Cap Structure, Asset Composition and Funding Stability charts to understand likely key driver. Have deposits grown rapidly? Or is the company growing loans at a faster pace than usual? Consider assumptions and scenarios around a deposit crunch and what that would mean for the company’s liquidity position.`,
      },
      property: {
        title: `Asset Liquidity Index`,
        subTitle: 'Cash / Current Assets',
        whatToShow: `Cash / Total Assets – standard deviations away from company history, and from country/sector peer group.`,
        purpose: `How liquid are the assets on the company balance sheet? Has this changed?`,
        thingsToLookOutFor: `A fall in this ratio may indicate that the company's cash levels have been drawn down - a sign of possible stress. Alternatively, it may indicate that the company is relying on non-cash items like accounts receivable or investments - which may increase the risk of future liquidity shock if these cannot be turned into cash when needed.`,
        nextBestAction: `If you see abnormal change in this chart, look at Chart Asset Structure for a basic idea of what's driving it. You'll find further detail in the Assets section of the company balance sheet. Think about the company's cash levels in conjunction with Chart Debt coverage burden and Chart Cash generation. Are cash levels being replenished well by profits? Can they support debt servicing requirements if needed? It might also be worth checking the cashflow statement of the company to see more detail if the company is burning cash. Think how long the cash will last at current burn, and stress test your models accordingly.`,
      },
    },
  },
  {
    id: 9,
    group: 'C',
    title: 'Earnings Yield Index',
    relationships: [8, 1],
    text:
      'How reliant is the capital structure on equity funding? Do current multiples imply any risk for leverage and funding in general?',
    mockData: earningsAndValuationRiskChartData,
    data: [],
    type: 'LineChart',
    lineKeys: {
      corporate: ['earnings_yield_deviation', 'earnings_yield_h_deviation'],
      bank: ['roe_pbr_deviation', 'roe_pbr_h_deviation'],
      property: ['earnings_yield_deviation', 'earnings_yield_h_deviation'],
    },
    tooltipInfo: {
      corporate: {
        title: `Market Valuation Index`,
        subTitle: '12mth Trailing Earnings Yield',
        whatToShow: `Market valuation – represented by 12m Trailing Earnings Yield - standard deviations away from company history, and from country/sector peer group.`,
        purpose: `Is the equity market pricing in downside risk? How available is equity financing if needed?`,
        thingsToLookOutFor: `Equity markets are heavily focused on earnings and are usually efficient at pricing to reflect changes in them. A rise in this ratio may indicate that equity markets see a deterioration or risk in earnings outlook. A fall may indicate lack of concern, but also a lack of price 'cushion’ if there is an earnings shock. Consider this chart in coordination with all others to get a sense of current risk/reward and/or market risk awareness on the company.`,
        nextBestAction: `Think about this chart in conjunction with chart Cost structure and chart Cash generation in particular. Does the valuation reflect the health of the company’s profits and cashflows or is there a mismatch? It’s also worth thinking about it in connection with chart Debt servicing - does the market imply a risk to earnings that could affect debt servicing? Finally, think about it in conjunction with the overall chart Capital structure. How reliant is the company on equity for its funding needs, and is there any risk that de-rating in equity multiples could hurt the company / create the need for asset liquidation or debt issuance?`,
      },
      bank: {
        title: `Market Valuation Index`,
        subTitle: 'ROE / Px Book',
        whatToShow: `Market valuation – represented by RoE / Px Book - standard deviations away from company history, and from country/sector peer group.`,
        purpose: `Is the equity market pricing in downside risk? How available is equity financing if needed?`,
        thingsToLookOutFor: `Bank equity tends to display a fairly stable relationship between RoE and Price-to-Book and markets are usually efficient at pricing to reflect changes in these ratios. A rise in this ratio may indicate that equity markets see a deterioration or risk in earnings outlook. A fall may indicate lack of concern, but also a lack of price 'cushion’ if there is an earnings shock. Consider this chart in coordination with all others to get a sense of current risk/reward and/or market risk awareness on the company.`,
        nextBestAction: `Think about this chart in conjunction with chart Cost structure and chart Cash generation in particular. Does the valuation reflect the health of the company’s profits and cashflows or is there a mismatch? It’s also worth thinking about it in connection with chart Debt servicing - does the market imply a risk to earnings that could affect debt servicing? Finally, think about it in conjunction with the overall chart Capital structure. How reliant is the company on equity for its funding needs, and is there any risk that de-rating in equity multiples could hurt the company / create the need for asset liquidation or debt issuance?`,
      },
      property: {
        title: `Market Valuation Index`,
        subTitle: '12mth Trailing Earnings Yield',
        whatToShow: `Market valuation – represented by 12m Trailing Earnings Yield - standard deviations away from company history, and from country/sector peer group.`,
        purpose: `Is the equity market pricing in downside risk? How available is equity financing if needed?`,
        thingsToLookOutFor: `Equity markets are heavily focused on earnings and are usually efficient at pricing to reflect changes in them. A rise in this ratio may indicate that equity markets see a deterioration or risk in earnings outlook. A fall may indicate lack of concern, but also a lack of price 'cushion’ if there is an earnings shock. Consider this chart in coordination with all others to get a sense of current risk/reward and/or market risk awareness on the company.`,
        nextBestAction: `Think about this chart in conjunction with chart Cost structure and chart Cash generation in particular. Does the valuation reflect the health of the company’s profits and cashflows or is there a mismatch? It’s also worth thinking about it in connection with chart Debt servicing - does the market imply a risk to earnings that could affect debt servicing? Finally, think about it in conjunction with the overall chart Capital structure. How reliant is the company on equity for its funding needs, and is there any risk that de-rating in equity multiples could hurt the company / create the need for asset liquidation or debt issuance?`,
      },
    },
  },
]

export default charts
